import clsx from "clsx";

export interface ButtonProps {
  text: string;
  variant?:
    | "primary"
    | "secondary"
    | "secondaryLight"
    | "underlined"
    | "ternary"
    | "black"
    | "white";
  size?: "sm" | "base" | "md" | "lg";
  width?: string;
  rounded?: "none" | "sm" | "base" | "md" | "lg" | "full";
  action?: () => void;
  className?: string;
  icon?: React.ReactNode;
}

export function Button(props: ButtonProps) {
  const { text, width, variant, size, action, className, rounded, icon } =
    props;

  const variants = {
    primary:
      "bg-primary-gray font-semibold text-sm text-primary-white border border-primary-gray transition-colors duration-300 ease-out",
    secondary:
      "font-bold text-[11px] text-[#787B80] uppercase border border-[#787B80] hover:bg-primary-blue hover:text-primary-white hover:border-primary-blue transition-colors duration-300 ease-out",
    secondaryLight:
      "font-bold text-[11px] text-white uppercase border border-white hover:bg-primary-blue hover:border-primary-blue transition-colors duration-300 ease-out",
    underlined: "text-[11px] underline",
    ternary: "text-[13px] underline",
    black:
      "w-full py-1.5 px-3 gap-2.5 bg-primary-gray text-[13px] font-medium text-primary-white tracking-[1%]",
    white:
      "w-full py-1.5 px-3 gap-2.5 text-[13px] font-medium  rounded-full tracking-[1%]",
  };

  const corners = {
    none: "rounded-none",
    sm: "rounded-sm",
    base: "rounded-base",
    md: "rounded-md",
    lg: "rounded-lg",
    full: "rounded-full",
  };

  const sizes = {
    none: "p-0",
    sm: "px-4 py-2",
    base: "px-4 py-3",
    md: "px-8 py-4",
    lg: "px-12 py-6",
  };

  return (
    <button
      className={clsx(
        "inline-flex items-center justify-center",
        variant && variants[variant],
        size && sizes[size],
        rounded && corners[rounded],
        width,
        className
      )}
      onClick={action}
    >
      {text}
      {icon && <span className="ml-2">{icon}</span>}
    </button>
  );
}

export default Button;
